import c from 'classnames';

import { Icon } from '@repo/ui';
import { Typography } from 'components';

import {
  ResourceFilters,
  TINY_PLUS_TAG_LABEL,
} from '../VideoResources.helpers';
import styles from './FilterBar.module.css';

interface FilterBarProps {
  // Curated tag pills that exist on at least one visible video.
  availableTags: string[];
  // False for viewers whose portal config hides upsells: there is no
  // exclusive content to filter to, so the pill would only lead to an empty state.
  showTinyPlusFilter: boolean;
  filters: ResourceFilters;
  onToggleTag: (tag: string) => void;
  onToggleTinyPlusOnly: (on: boolean) => void;
}

export const FilterBar = ({
  availableTags,
  showTinyPlusFilter,
  filters,
  onToggleTag,
  onToggleTinyPlusOnly,
}: FilterBarProps) => (
  <div className={styles.filterBar}>
    <div className={styles.filterIcon}>
      <Icon name='filterLines' size='m' />
    </div>
    {availableTags.map(tag => (
      <button
        key={tag}
        type='button'
        className={c(
          styles.filterChip,
          filters.tags.includes(tag) && styles.active,
        )}
        onClick={() => onToggleTag(tag)}
      >
        <Typography variant='body-s'>{tag}</Typography>
      </button>
    ))}
    {showTinyPlusFilter && (
      <button
        type='button'
        className={c(styles.filterChip, filters.tinyPlusOnly && styles.active)}
        onClick={() => onToggleTinyPlusOnly(!filters.tinyPlusOnly)}
      >
        <Icon name='awardFilled' size='r' />
        <Typography variant='body-s'>{TINY_PLUS_TAG_LABEL}</Typography>
      </button>
    )}
  </div>
);
